<template lang="pug">
.card.market-card
  .card-header.bg-more-head.collapse-more(
    :id="'heading-corner-' + childId"
    data-toggle='collapse'
    :data-target="'#collapse-corner-' + childId"
    :aria-controls="'collapse-corner-' + childId"
    aria-expanded=true
  )
    .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ leagueName.trim() }}
  .collapse.show(
    :aria-labelledby="'heading-corner-' + childId"
    :id="'collapse-corner-' + childId"
  )
    .card-body.p-0
      .market-card-content
        .match(:class="{ 'live' : source.match[4] == 3 }")
          .match-info
            .d-flex.match-info-team
              .match-info-home-name(:class="source.team == 1 ? 'team-red' : 'team-black'")
                .name {{ source.match[5] }}
              TimePanel(:source="source" mode=true)
              .match-info-away-name(:class="source.team == 0 ? 'team-red' : 'team-black'")
                .name {{ source.match[6] }}
        .normal
          .normal-title {{ $t("ui.full_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Over") }}
              template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
                OddsItem(:odds="source['ou'][0]" idx=12 :typ="oddsType" dataType="1" mode="ou" label="over" count="0" :details="source" homeAway="1")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Under") }}
              template(v-if="source['ou'] && source['ou'][0] && source['ou'][0][11] != 0 && source['ou'][0][12] != 0 && source['ou'][0][11] != '' && source['ou'][0][12] != ''")
                OddsItem(:odds="source['ou'][0]" idx=11 :typ="oddsType" dataType="1" mode="ou" label="under" count="0" :details="source" homeAway="2")
              template(v-else)
                OddsDisabled
        .normal
          .normal-title {{ $t("ui.half_time") }}
          .normal-odd-area
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Over") }}
              template(v-if="source['ouh'] && source['ouh'][0] && source['ouh'][0][11] != 0 && source['ouh'][0][12] != 0 && source['ouh'][0][11] != '' && source['ouh'][0][12] != ''")
                OddsItem(:odds="source['ouh'][0]" idx=12 :typ="oddsType" dataType="1" mode="ouh" label="over" count="0" :details="source" homeAway="1")
              template(v-else)
                OddsDisabled
            .normal-odd-area-group
              .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.ODD_Under") }}
              template(v-if="source['ouh'] && source['ouh'][0] && source['ou'][0][11] != 0 && source['ouh'][0][12] != 0 && source['ouh'][0][11] != '' && source['ouh'][0][12] != ''")
                OddsItem(:odds="source['ouh'][0]" idx=11 :typ="oddsType" dataType="1" mode="ouh" label="under" count="0" :details="source" homeAway="2")
              template(v-else)
                OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";
import TimePanel from "@/components/mobile/main/timePanel";

export default {
  components: {
    OddsItem,
    OddsDisabled,
    TimePanel
  },
  mixins: [mixinHDPOUOdds],
  props: {
    childId: {
      type: Number
    },
    mode: {
      type: Number
    }
  },
  computed: {
    leagueName() {
      var result = this.source["league"].split(" - ");
      if (result.length >= 2) {
        return result[result.length - 1];
      }
      return this.source["league"];

      // var result = this.source["match"][5];
      // if (result) {
      //   result = result.split(" ");
      //   if(result.length > 2) {
      //     result = this.source["league"].split("-");
      //     console.log(result.length)
      //     return result[result.length - 1];
      //   } else {
      //     return result[result.length - 2] + " " + result[result.length - 1];
      //   }
      // } else {
      //   return this.source["league"];
      // }
    }
  }
}
</script>